<template>
  <el-menu
    :default-active="activeMenu"
    class="el-menu-vertical-demo"
    @select="routeTo"
    background-color="#464c5b"
    text-color="#fff"
    active-text-color="#ffd04b"
    :unique-opened="true"
    :collapse="false">
    <div class="layout-logo-left">惠民中台</div>
    
    <el-menu-item index="dashboard" v-if="permissions['dashboard']">
      <i class="el-icon-monitor"></i>
      <span slot="title">{{permissions['dashboard'].menuName}}</span>
    </el-menu-item>
    
    <el-submenu index="admin" v-if="permissions['admin']">
      <template slot="title">
        <i class="el-icon-setting"></i>
        <span>{{permissions['admin'].menuName}}</span>
      </template>
      <el-menu-item index="admin:user" v-if="permissions['admin:user']">{{permissions['admin:user'].menuName}}</el-menu-item>
      <el-menu-item index="admin:role" v-if="permissions['admin:role']">{{permissions['admin:role'].menuName}}</el-menu-item>
      <el-menu-item index="admin:permission" v-if="permissions['admin:permission']">{{permissions['admin:permission'].menuName}}</el-menu-item>
    </el-submenu>
    
    <el-submenu index="link" v-if="permissions['link']">
      <template slot="title">
        <i class="el-icon-link"></i>
        <span>{{permissions['link'].menuName}}</span>
      </template>
      <el-menu-item index="link:dynamic" v-if="permissions['link:dynamic']">{{permissions['link:dynamic'].menuName}}</el-menu-item>
      <el-menu-item index="link:stats" v-if="permissions['link:stats']">{{permissions['link:stats'].menuName}}</el-menu-item>
    </el-submenu>
  </el-menu>
</template>

<script>
import EventBus from '@/event_bus';

export default {
  name: 'SideMenu',
  props: ['permissions'],
  data() {
    return {
      menuItemArr: [],
      activeMenu: ''
    };
  },
  computed: {
  },
  methods: {
    routeTo(route) {
      if (route) {
        const toRoute = `/${route.split(':').join('/')}`;
        this.$router.push(toRoute);
      }
    }
  },
  created() {
    const route = this.$router.currentRoute;
    const path = route.path.substr(1);
    this.menuItemArr = [path.split('/')[0]];
    this.activeMenu = path.split('/').join(':');

    // 路由改变更新menu
    EventBus.$on('route-change', (data) => {
      const toRoute = data.to;
      const toPath = toRoute.path.substr(1);
      this.menuItemArr = [toPath.split('/')[0]];
      this.activeMenu = toPath.split('/').join(':');
    });
  }
};
</script>

<style scoped>
.layout-logo-left {
  height: 30px;
  line-height: 30px;
  background: #ffffff;
  border-radius: 3px;
  margin: 15px;
  text-align: center;
  font-size: 16px;
  color: #333;
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  min-height: 400px;
}
</style>



// WEBPACK FOOTER //
// src/components/layout/SideMenu.vue